import { Grid, Typography } from '@mui/material';

function ContactModalStats(props) {
  return (
    <Grid container alignItems={'center'} spacing={1}>
      <Grid item md={2}>
        <props.icon
          style={{
            background: '#febd1c22',
            fontSize: '20px',
            borderRadius: 50,
            padding: 10,
            color: '#febd1c',
            marginTop: '5px',
          }}
        ></props.icon>
      </Grid>
      <Grid item md={10}>
        <Grid container direction={'column'} style={{ marginLeft: '10px' }}>
          <Grid item>
            <Typography style={{ fontSize: '13px', color: '#707070' }}>{props.heading}</Typography>
          </Grid>
          <Grid item>
            <Grid container direction={'column'}>
              {props.data
                ? props.data.map((val) => (
                    <Grid item style={{ cursor: props.open === 'yes' ? 'pointer' : '' }}>
                      <Typography
                        style={{ marginTop: '0px', fontSize: '11px' }}
                        onClick={() =>
                          props.open === 'yes' ? window.open(val ? val : '', '_blank') : ''
                        }
                      >
                        {val ? (val.length > 35 ? `${val.slice(0, 35)}...` : val) : ''}
                      </Typography>
                    </Grid>
                  ))
                : ''}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ContactModalStats;
